import { useEffect } from 'react'
import { toast } from 'react-toastify'
import { StringParam, useQueryParams } from 'use-query-params'

export const ToastHandler = () => {
  const [{ sm, em }, setQuery] = useQueryParams({
    sm: StringParam,
    em: StringParam,
  })

  useEffect(() => {
    if (sm) toast.success(decodeURI(sm))
    if (em) toast.error(decodeURI(em))
    setQuery({ sm: undefined, em: undefined })
  }, [sm, em, setQuery])
  return null
}
